<template>
  <div id="add-item-wrapper">
    <b-form class="flex">
      <div><label class="add-item-label">เพิ่มรายการสินค้า</label></div>
      <div class="input-wrapper mt-2 mr-1">
        รหัสสินค้า
      </div>
      <div>
        <multiselect
          v-model="itemInput"
          :tabindex="-1"
          :options="getItems"
          label="item_code"
          track-by="id"
          select-label=""
          deselect-label="✖"
          selected-label=""
          placeholder="รหัสสินค้า"
        />
      </div>
      <div class=" mt-2 ml-3 mr-1">
        ชื่อสินค้า
      </div>
      <div>
        <multiselect
          v-model="itemInput"
          :tabindex="-1"
          :options="getItems"
          label="name"
          track-by="id"
          select-label=""
          deselect-label="✖"
          selected-label=""
          placeholder="ชื่อสินค้า"
        />
      </div>
      <div class=" mt-2 ml-3 mr-1">
        ราคา
      </div>
      <div>
        <b-form-input
          id="item-price"
          v-model="item_price"
          type="number"
          class="add-input-box"
          required
        />
      </div>
      <div class=" mt-2 ml-3 mr-1">
        จำนวน
      </div>
      <div>
        <b-form-input
          id="item-quantity"
          v-model="item_quantity"
          type="number"
          class="add-input-quantity-box"
          required
          @change="item_quantityHandler"
        />
      </div>
      <b-button class="ml-2 px-5 add-item-btn" @click="onSubmit">
        เพิ่ม
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "AddItemmOtherPlatformComponent",
  props: {
    addItemInput: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      getItems: "Item/getItems",
    }),
  },
  data() {
    return {
      item_quantity: "",
      item_price: "",
      item_name: "",
      item_code: "",
      itemInput: null,
    };
  },
  created() {
    this.setItems();
  },
  methods: {
    ...mapActions({
      setItems: "Item/setItems",
    }),
    onSubmit() {
      if (
        this.item_code === "" ||
        this.item_name === "" ||
        this.item_price === "" ||
        this.item_quantity === ""
      ) {
        this.$swal.fire("input invalid.");
      } else {
        this.$emit("update:addItemInput", {
          item_code: this.item_code,
          item_name: this.item_name,
          item_price: this.item_price,
          item_quantity: this.item_quantity,
        });
      }
    },
    item_quantityHandler(val) {
      val = _.floor(+val);
      if (val <= 0) {
        this.$swal.fire(`จำนวนสินค้าต้องมากกว่า 1`);
        this.item_quantity = 1;
      } else {
        this.item_quantity = val;
      }
    },
  },
  watch: {
    itemInput(newVal, oldVal) {
      this.item_price = this.itemInput.price;
      this.item_code = this.itemInput.item_code;
      this.item_name = this.itemInput.name;
    },
    item_price(val) {
      if (val <= 0) {
        this.$swal.fire(`ราคาสินค้าต้องมีมากกว่า 0.01 บาท`);
        this.item_price = 1;
      }
    },
    item_quantity(val) {
      val = parseInt(val);
      if (val <= 0) {
        this.$swal.fire(`จำนวนสินค้าต้องมากกว่า 1`);
        this.item_quantity = 1;
      }
    },
  },
};
</script>

<style scoped>
#add-item-wrapper {
  background-color: #eaeced;
  margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 50px;
}

.flex {
  display: flex;
  margin-right: 10px;
  margin-left: 5px;
}
.select-box {
  margin: 0px 5px 0px 5px;
  width: 20vw;
}
.input-wrapper {
  margin-left: 5rem;
}
.add-input-box {
  width: 10rem;
}
.add-input-quantity-box {
  width: 5rem;
}
.add-item-btn {
  background-color: #fb822b;
  color: white;
  border: none;
}
.add-item-label {
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  font-weight: bold;
}
</style>
